import React, { useEffect, useRef } from 'react';
import './WebsiteTranslator.css';

const WebsiteTranslator = () => {
  const elfsightRef = useRef(null);

  useEffect(() => {
    // Check if Elfsight script is already loaded
    if (window.ElfSight) {
      initializeWidget();
      return;
    }

    // Load Elfsight platform script
    const script = document.createElement('script');
    // script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    script.onload = () => {
      console.log('Elfsight platform loaded');
      initializeWidget();
    };
    script.onerror = () => {
      console.error('Failed to load Elfsight platform');
    };

    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // Remove any Elfsight related elements if needed
      const existingScript = document.querySelector('script[src*="elfsightcdn.com"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  const initializeWidget = () => {
    if (window.ElfSight && elfsightRef.current) {
      // Elfsight should automatically initialize widgets with data-elfsight-app-lazy
      console.log('Elfsight translator widget initialized');
    }
  };

  return (
    <div className="elfsight-translator-container">
      {/* Elfsight Website Translator Widget */}
      <div 
        ref={elfsightRef}
        className="elfsight-app-b0189deb-f76c-4696-81cd-5d7b5fdf191c"
        data-elfsight-app-lazy
      />
    </div>
  );
};

export default WebsiteTranslator;